import type { ObjectAny, WithHash } from '@pressreader/types';

export const extendObjectWithHash = <T extends ObjectAny>(object: T, hash: string): WithHash<T> => {
    return {
        ...object,
        hash,
    };
};
